import {
  Directive,
  effect,
  ElementRef,
  HostListener,
  inject,
  input,
  InputSignal,
} from '@angular/core';

const MD_BREAKPOINT = 768;

@Directive({
  selector: '[awPopupPosition]',
})
export class PopupPosition {
  public readonly isVisible: InputSignal<boolean> = input.required();
  public readonly anchor: InputSignal<string> = input.required();
  public readonly limitMaxWidth: InputSignal<boolean> = input(true);
  private readonly element: ElementRef = inject(ElementRef);
  private isUp: boolean = false;
  private isMobile: boolean = false;

  @HostListener('window:wheel', ['$event'])
  onScroll() {
    this.positionElement(this.isVisible());
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.positionElement(this.isVisible());
  }

  constructor() {
    effect(() => {
      this.positionElement(this.isVisible());
    });
  }

  private positionElement(isVisible: boolean): void {
    const rect: DOMRect = this.element.nativeElement.getBoundingClientRect();
    const anchor: string | undefined = this.anchor();
    const el: HTMLElement | null = anchor
      ? document.getElementById(anchor)
      : null;
    if (!el) {
      console.warn(`Missing anchor element for popup ${this.anchor()}`);
      return;
    }
    const anchorRect: DOMRect = el.getBoundingClientRect();

    if (this.limitMaxWidth() && !this.isMobile) {
      this.element.nativeElement.style.width = anchorRect.width + 'px';
      this.element.nativeElement.style.maxWidth = anchorRect.width + 'px';
    } else if (!this.limitMaxWidth()) {
      this.element.nativeElement.style.width = 'initial';
    }

    if (
      (rect.height > window.innerHeight ||
        window.innerWidth <= MD_BREAKPOINT) &&
      !this.isMobile
    ) {
      this.isMobile = true;
      this.element.nativeElement.style.position = 'fixed';
      this.element.nativeElement.style.top = '0';
      this.element.nativeElement.style.left = '0';
      this.element.nativeElement.style.right = '0';
      this.element.nativeElement.style.bottom = '0';
      this.element.nativeElement.style.height = '100%';
      this.element.nativeElement.style.maxHeight = 'initial';
    } else if (
      this.isMobile &&
      window.innerWidth >= MD_BREAKPOINT &&
      rect.height < window.innerHeight
    ) {
      this.isMobile = false;
      this.element.nativeElement.style.position = 'fixed';
      this.element.nativeElement.style.left = '';
      this.element.nativeElement.style.right = '';
      this.element.nativeElement.style.height = '';
      this.element.nativeElement.style.maxHeight = '';
      this.element.nativeElement.style.maxWidth = '';
      this.element.nativeElement.style.width = '10%';
    }

    if (
      (window.innerHeight < anchorRect.bottom + rect.height ||
        (this.isMobile && this.isUp)) &&
      isVisible
    ) {
      this.isUp = true;
    } else if (anchorRect.bottom + rect.height < window.innerHeight) {
      this.isUp = false;
    }

    if (!this.isMobile) {
      if (this.isUp) {
        this.element.nativeElement.style.top =
          anchorRect.bottom - rect.height + 'px';
      } else if (!this.isUp) {
        this.element.nativeElement.style.top = anchorRect.bottom + 'px';
      }
    } else {
      this.element.nativeElement.style.maxWidth = '';
      this.element.nativeElement.style.width = '100%';
    }
  }
}
